export default __webpack_public_path__ + "static/media/arrow-left.ce7d44e6.svg";